var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDummyAssetOptimized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#d9d9d9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.8,78.1H59.2c-1.1,0-2,0.9-2,2v89.8c0,1.1,0.9,2,2,2h131.5c1.1,0,2-0.9,2-2V80.1 C192.7,79,191.8,78.1,190.8,78.1z M83.3,91.1c7.2,0,13,5.8,13,13c0,7.2-5.8,13-13,13c-7.2,0-13-5.8-13-13 C70.3,97,76.1,91.1,83.3,91.1z M177.1,156.3H72.9v-15.6l12.9-12.9c1.5-1.5,4-1.5,5.5,0l12.9,12.9l38.9-38.9c1.5-1.5,4-1.5,5.5,0 l28.5,28.5V156.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0v250h250V0H0z M208.3,171.9c0,8.6-7,15.6-15.6,15.6H57.3c-8.6,0-15.6-7-15.6-15.6V78.1 c0-8.6,7-15.6,15.6-15.6h135.4c8.6,0,15.6,7,15.6,15.6V171.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyAssetOptimized);
export default __webpack_public_path__ + "static/media/DummyAsset_optimized.2413aa7ab8a0b7ec2ad61c6734c30d25.svg";
export { ForwardRef as ReactComponent };